import { render, staticRenderFns } from "./SortMaterial.vue?vue&type=template&id=109382a8&scoped=true&"
import script from "./SortMaterial.vue?vue&type=script&lang=js&"
export * from "./SortMaterial.vue?vue&type=script&lang=js&"
import style0 from "./SortMaterial.vue?vue&type=style&index=0&id=109382a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109382a8",
  null
  
)

export default component.exports